import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.setNewFormModal()
    document.querySelector('#close_member_modal').addEventListener('click', this.showConfirmationPopUp.bind(this))
    document.body.addEventListener('keydown', this.closeOnEscape.bind(this))
    $('#new_member_modal').on('hidden.bs.modal', this.resetFormFields.bind(this));
  }

  disconnect() {
    document.body.removeEventListener('keydown', this.closeOnEscape)
  }

  showConfirmationPopUp(event){
    event.preventDefault();
    $('#member_confirmation_modal').modal('show');
    $('#new_member_modal').modal('hide');
  }
  
  closeMemberModal(){
    $('#member_confirmation_modal').modal('hide');
    $('#new_member_modal').modal('hide');
    this.resetFormFields();
  }
  
  closeWarningModal(){
    $('#member_confirmation_modal').modal('hide');
    setTimeout(() => {
      $('#new_member_modal').modal('show');
    }, 500);
  }
  
  setNewFormModal(){
    if ($('#new_member_modal').data('showModal')){
      $('#new_member_modal').modal('show');
    }
  }

  closeOnEscape(event) {
    if (event.keyCode === 27) {
      this.closeMemberModal();
    }
  }

  resetFormFields() {
    const form = document.querySelector('#new_affiliate_member');
    form.querySelectorAll('input, textarea, select').forEach((element) => {
      if (element.type !== 'submit') {
        if (element.tagName === 'SELECT') {
          if ($(element).hasClass('select2-hidden-accessible')) {
            $(element).val(null).trigger('change');
          } else {
            element.selectedIndex = 0;
          }
        } else {
          element.value = '';
        }
      }

      const errorSpan = element.parentElement.querySelector('.help-block.text-danger');
      if (errorSpan) {
        errorSpan.textContent = '';
      }
    });
  }
}
